export default require('js-event-bus')();

